module.exports = __webpack_public_path__ + "static/media/crossed-swords_2694.2205f39b.png";